import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { LoadingOverlay } from '../LoadingOverlay';

const TableWrapper = styled.table`
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08), 0 1.5px 4px rgba(0,0,0,0.06);
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fff;
    position: relative;
`;

interface TableProps {
    children: ReactNode;
    className?: string;
    loading?: boolean;
}

const Table: React.FC<TableProps> = ({ children, className, loading }) => {
    return <TableWrapper className={className}>{loading && <LoadingOverlay />}{children}</TableWrapper>;
};

export default Table;
